import * as React from 'react';
import Select from 'react-select';
import { Button, FormControl, HelpBlock, InputGroup } from 'react-bootstrap';
import FaSpinner from 'react-icons/fa/spinner';
import FaSearch from 'react-icons/fa/search';
import { WrappedFieldProps } from 'redux-form';
import { OptionComponent, valueComponent } from '../../helpers/SessionCam';
import { IPostcodeAddress, IPostcodeLookup } from '../../data/api/models';
import * as api from '../../data/api/api';

interface IPostcodeControlProps extends WrappedFieldProps {
  className: string;
  [option: string]: any;
  onSelectAddress(address: IPostcodeAddress): void;
}

interface IPostcodeControlState {
  isSearching: boolean;
  addresses: IPostcodeLookup[];
}

class PostcodeControl extends React.Component<IPostcodeControlProps, IPostcodeControlState> {
  public state = {
    isSearching: false,
    addresses: [],
  };

  private searchPostcode = () => {
    const { input } = this.props;

    this.setState({ isSearching: true });

    api.lookupPostcode(input.value)
      .then((addresses) => {
        this.setState({
          isSearching: false,
          addresses,
        });
      });
  }

  private selectAddress = (item) => {
    const { onSelectAddress } = this.props;

    this.setState({
      isSearching: true,
      addresses: [],
    });

    api.getPostcode(item.value)
      .then((address) => {
        this.setState({
          isSearching: false,
        });

        onSelectAddress(address);
      });
  }

  public render() {
    const { input, className, meta, onSelectAddress, ...props } = this.props;
    const { isSearching, addresses } = this.state;

    const list = addresses.length > 0 ? addresses.map((address: IPostcodeLookup) => {
      return {
        label: address.line,
        value: address.id,
      };
    }) : [];

    return (
      <div className={meta.touched && meta.error ? 'has-error' : ''}>
        <InputGroup>
          <FormControl
            type="text"
            placeholder="Postcode"
            className={meta.dirty ? className + ' dirty-field' : className}
            {...input}
            {...props}
          />
          <InputGroup.Button>
            <Button
              bsStyle="primary"
              className="btn-postcode"
              type="button"
              disabled={isSearching || !input.value}
              onClick={this.searchPostcode}
            >
              {isSearching
                ? (<FaSpinner className="fa-spin"/>)
                : (<FaSearch />)} <span>Lookup</span>
            </Button>
          </InputGroup.Button>
        </InputGroup>

        {addresses.length > 0 && (
          <div>
            <br />
            <Select
              value={input.value}
              valueComponent={valueComponent}
              className={meta.dirty ? className + ' dirty-field' : className}
              onChange={this.selectAddress}
              options={list}
              optionComponent={OptionComponent}
              placeholder="Select Address..."
              clearable={false}
            />
          </div>
        )}

        {meta.touched && meta.error && <HelpBlock>{meta.error}</HelpBlock>}
      </div>
    );
  }
}

export default PostcodeControl;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/components/PostcodeControl/index.tsx